// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#scbd-search[data-v-07207a17]{position:relative;width:100%}.loading[data-v-07207a17]{position:fixed;bottom:0;left:50%;background-color:#deb887}.stick[data-v-07207a17]{position:sticky;z-index:5;top:0}", ""]);
// Exports
module.exports = exports;
